// actions/chat/chat.js

import PubSub         from 'pubsub-js';
import { attachAuth } from '../../utils/authService';

// --- ALL ---

export function chatHasErrored(bool) {
  return {
    type: 'CHAT_HAS_ERRORED',
    hasErrored: bool
  };
}

export function chatIsLoading(bool) {
  return {
    type: 'CHAT_IS_LOADING',
    isLoading: bool
  };
}

export function chatFetchDataSuccess(response) {
  return {
    type: 'CHAT_FETCH_DATA_SUCCESS',
    response
  };
}

export function chatFetchData(host, msg) {
  return (dispatch) => {
    dispatch(chatIsLoading(true));
    dispatch(chatHasErrored(false));
    fetch(host + 'catalog/chat', {
      method: 'post',
      body: JSON.stringify(msg),
      headers: attachAuth()
    }).then(promise => {
        if (!promise.ok) {
          throw Error(promise.statusText);
        
        }
        promise.json()
          .then(result => {
            dispatch(chatFetchDataSuccess(result));
            dispatch(chatHasErrored(false));
            dispatch(chatIsLoading(false));
            PubSub.publish('chat.response', result);
          })
          .catch((ex) => {
            console.log(ex);
            dispatch(chatHasErrored(true));
            dispatch(chatIsLoading(false));
            PubSub.publish('chat.response', 'An error occurred');
          });
    })
    .catch((ex) => {
      console.log(ex);
      dispatch(chatHasErrored(true));
      dispatch(chatIsLoading(false));
    });
  };
}